import { useContext, useEffect } from "react";
import { useSeasons } from "./useSeasons";
import { ProjectContext } from "./projectContext";
import { useSnapshot } from "./useSnapshot";
import {
  onAllLatestScriptReferences,
  ScriptReference,
} from "@atgof-common/script";
import { getScript } from "./backend";

export function useScriptPreloader() {
  const { preloadScripts } = useContext(ProjectContext);
  const seasons = useSeasons(false);
  const seasonRef =
    preloadScripts && seasons?.length ? seasons[0].ref : undefined;
  const scriptReferences = useSnapshot<ScriptReference[] | undefined>(
    seasonRef
      ? (onNext) => onAllLatestScriptReferences(seasonRef, onNext)
      : undefined,
    [seasonRef?.path],
  );
  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      for (const { sceneRef, scriptPath } of scriptReferences ?? []) {
        if (cancelled) break;
        await getScript(sceneRef, scriptPath);
      }
    };
    run();
    return () => {
      cancelled = true;
    };
  }, [scriptReferences]);
}
